import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  ButtonModule,
  FormFieldModule,
  SectionComponent,
  TypographyModule,
} from "@bitwarden/components";
import { SendFileDetailsComponent } from "@bitwarden/send-ui";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  selector: "app-bv-send-file-details",
  templateUrl: "./bv-send-file-details.component.html",
  imports: [
    ButtonModule,
    I18nPipe,
    ReactiveFormsModule,
    FormFieldModule,
    SectionComponent,
    FormsModule,
    TypographyModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BvSendFileDetailsComponent extends SendFileDetailsComponent {}
